import BaseService from "../BaseService";
import _ from "lodash";

class LoginServices extends BaseService {
    workSpaceLogin = async ({ w_id, user_name, pass }) => {
        var data = await this._api.post("workspace/login", { w_id, user_name, pass });
        return data;
    }


    userLogin = async (payload) => {
        var data = await this._api.post("login", payload);
        return data;
    }


    loginWithGoogle = async (token) => {
        var data = await this._api.post("loginwithgoogle", { token });
        return data;
    }



}
export default LoginServices;
